module.exports = __webpack_public_path__ + "static/media/calendar.d3393994.svg";